import React from 'react';
import {withRouter, useHistory} from 'react-router-dom';
import {generateMapBackground, isWithinAbsencePeriod} from '../../utils';
import moment from 'moment';
import {extendMoment} from 'moment-range';
import {useTranslation} from "react-i18next";

// React Components
import ContactsList from "../ContactsList";

// Icons
import Trophy from '../../assets/images/mygames/game_card_trophy.svg';
import WaitingClock from './../../assets/images/waiting_icon.svg';

// CSS Files
import "./styles.css";

const GameCard = (props) => {
   const history = useHistory();
   const { t } = useTranslation();
   let gameTimeMoment;
   let gameWeekStartDate = new Date(props.gameInfo.start_date);
   let gameWeekEndDate = new Date(props.gameInfo.end_date);
   let absenceReason = props.gameInfo.opponent_absence_reason;
   let absenceStartDate = new Date(props.gameInfo.opponent_absence_start_date);
   let absenceEndDate = new Date(props.gameInfo.opponent_absence_end_date);

   if (props.gameInfo.game_time !== undefined) {
      gameTimeMoment = moment(props.gameInfo.game_time).utc();
   }

   const isValidDate = date => date instanceof Date && !isNaN(date.getTime());
   const hasAbsencePeriod = isValidDate(absenceStartDate) && isValidDate(absenceEndDate);
   const isToScheduleDuringAbsence = props.gameInfo.state === "to_schedule" &&
      hasAbsencePeriod &&
      isWithinAbsencePeriod(new Date(), absenceStartDate, absenceEndDate);
   const isScheduledDuringAbsence = props.gameInfo.state === "scheduled" &&
      hasAbsencePeriod &&
      gameTimeMoment &&
      isWithinAbsencePeriod(gameTimeMoment.toDate(), absenceStartDate, absenceEndDate);
   const hasSchedulingRelevantAbsence = isToScheduleDuringAbsence ||
      isScheduledDuringAbsence ||
      ["Procuro substituta/o", "Queremos desistir"].includes(absenceReason);

   return (
      <div
         className={`game-card${props.results ? " mb-0" : ""}${(props.contacts || !["/my-games", "/schedule"].includes(history.location.pathname)) ? " cursor-default" : ""}${isToScheduleDuringAbsence || isScheduledDuringAbsence ? " opaque" : ""}`}
         onClick={() => {
            if (!props.contacts && (history.location.pathname === "/my-games" || history.location.pathname === "/schedule")) {
               if (["to_schedule", "suspended", "absence_a", "absence_b"].includes(props.gameInfo.state))
                  history.push(`/my-games/game/${props.gameInfo.id}`);

               if (props.gameInfo.state === "scheduled")
                  history.push(`/my-games/game/${props.gameInfo.id}/scheduled`);

               if (props.gameInfo.state === "played")
                  history.push(`/my-games/game/${props.gameInfo.id}/played`);
            }
         }}>
         {!props.contacts &&
            <div className="game-card-streak-wrapper">
               <div className={"game-card-streak game-card-streak-header" + (props.results ? " results" : "")}>
                  {props.results ? <span className="game-card-streak-header-jornada">{t("played_match_page.score")}</span> : <>
                     <span className="game-card-streak-header-jornada">{t("common.game_week").toUpperCase()} {props.gameInfo.week_number}</span>
                     <span>
            {props.gameInfo.state !== "played" ?
               (moment(props.gameInfo.start_date).format(`${t("common.date_formatting.day")} MMM`) + " - " + moment(props.gameInfo.end_date).format(`${t("common.date_formatting.day")} MMM`)) :
               (gameTimeMoment.format(`${t("common.date_formatting.day")} MMMM HH[h]`))
            }
          </span>
                  </>}
               </div>
            </div>
         }
         <div className={"game-card-body-wrapper" + (props.gameInfo.state === "played" ? " finished" : "")}>
            <div className={"game-card-body" + (props.gameInfo.state === "played" ? " finished" : "") + (props.contacts ? " contacts" : "")}>
               <div className={"game-card-team" + (props.gameInfo.state === "played" || props.contacts ? " team-a" : "")}>
                  <div className="game-card-person">
                     <div style={{backgroundImage: "url(" + props.gameInfo.teams.a[0].image + ")"}}/>
                     <span>{props.gameInfo.teams.a[0].name}</span>
                     {props.contacts &&
                        <ContactsList email={props.gameInfo.teams.a[0].email} phoneNumber={props.gameInfo.teams.a[0].phone_number}/>
                     }
                  </div>
                  <div className="flex-gap"/>
                  <div className="game-card-person">
                     <div style={{backgroundImage: "url(" + props.gameInfo.teams.a[1].image + ")"}}/>
                     <span>{props.gameInfo.teams.a[1].name}</span>
                     {props.contacts &&
                        <ContactsList email={props.gameInfo.teams.a[1].email} phoneNumber={props.gameInfo.teams.a[1].phone_number}/>
                     }
                  </div>
               </div>
               {(props.gameInfo.state === "played" || props.contacts) && <div className="game-card-team-finished-gap"/>}
               <div className="game-card-team team-b">
                  <div className="game-card-person">
                     <div style={{backgroundImage: "url(" + props.gameInfo.teams.b[0].image + ")"}}/>
                     <span>{props.gameInfo.teams.b[0].name}</span>
                     {props.contacts &&
                        <ContactsList email={props.gameInfo.teams.b[0].email} phoneNumber={props.gameInfo.teams.b[0].phone_number}/>
                     }
                  </div>
                  <div className="flex-gap"/>
                  <div className="game-card-person">
                     <div style={{backgroundImage: "url(" + props.gameInfo.teams.b[1].image + ")"}}/>
                     <span>{props.gameInfo.teams.b[1].name}</span>
                     {props.contacts &&
                        <ContactsList email={props.gameInfo.teams.b[1].email} phoneNumber={props.gameInfo.teams.b[1].phone_number}/>
                     }
                  </div>
               </div>
            </div>
            {!props.contacts && props.gameInfo.state === "played" && (<div className="game-card-results">
               <div className="game-card-result">
                  <div className="game-card-result-body">
                     <span className={(props.gameInfo.scores.a[0] >= props.gameInfo.scores.b[0]) ? 'highest-score' : ''}>{props.gameInfo.scores.a[0]}</span>
                     <span className={(props.gameInfo.scores.a[1] >= props.gameInfo.scores.b[1]) ? 'highest-score' : ''}>{props.gameInfo.scores.a[1]}</span>
                     {props.gameInfo.scores.a[2] &&
                        <span className={(props.gameInfo.scores.a[2] >= props.gameInfo.scores.b[2]) ? 'highest-score' : ''}>{props.gameInfo.scores.a[2]}</span>
                     }
                     <div className="game-card-result-trophy">
                        {props.gameInfo.winning_team === "a" && (<img src={Trophy} alt="Vencedores"/>)}
                     </div>
                  </div>
               </div>
               <div className="game-card-team-finished-gap"/>
               <div className="game-card-result">
                  <div className="game-card-result-body">
                     <span className={(props.gameInfo.scores.b[0] >= props.gameInfo.scores.a[0]) ? 'highest-score' : ''}>{props.gameInfo.scores.b[0]}</span>
                     <span className={(props.gameInfo.scores.b[1] >= props.gameInfo.scores.a[1]) ? 'highest-score' : ''}>{props.gameInfo.scores.b[1]}</span>
                     {props.gameInfo.scores.b[2] &&
                        <span className={(props.gameInfo.scores.b[2] >= props.gameInfo.scores.a[2]) ? 'highest-score' : ''}>{props.gameInfo.scores.b[2]}</span>
                     }
                     <div className="game-card-result-trophy">
                        {props.gameInfo.winning_team === "b" && (<img src={Trophy} alt="Vencedores"/>)}
                     </div>
                  </div>
               </div>
            </div>)}
            {!props.contacts && props.gameInfo.state === "scheduled" && (
               <div className={"game-card-map"}
                    style={generateMapBackground(props.gameInfo.location)}>
                  <div className="game-card-map-date-container">
                     <span className="game-card-map-date-day">{gameTimeMoment.format('DD')}</span>
                     <span className="game-card-map-date-month">{gameTimeMoment.format('MMM')}</span>
                     <span className="game-card-map-date-time">{gameTimeMoment.format('HH[h]mm')}</span>
                  </div>
                  <div className="game-card-map-location-container">
                     <span className="game-card-map-location-name">{props.gameInfo.location?.name}</span>
                     <span>{props.gameInfo.location?.address}</span>
                     <span>{props.gameInfo.location?.postal}</span>
                  </div>
               </div>
            )}
         </div>

         {props.streakText && !(isToScheduleDuringAbsence || isScheduledDuringAbsence) &&
            <div className="game-card-streak-wrapper">
               <div className={"game-card-streak game-card-streak-footer" + (props.streakColor === "red" ? " red" : "") + (props.streakColor === "green" ? " green" : "")}>
                  <span className={"game-card-footer-suspended"}>{props.streakText}</span>
               </div>
            </div>
         }

         {hasSchedulingRelevantAbsence &&
            <div>
               {absenceReason === "Queremos desistir" ?
                  <p className={"absence-warning"}>{t("game_card.schedule_another_req").toUpperCase()}</p>
                  :
                  <p className={"absence-warning"}>{t("game_card.schedule_another_non_req").toUpperCase()}</p>
               }
               <div className="game-card-streak-wrapper">
                  <div className={"d-flex align-items-center game-card-streak game-card-streak-footer" + (props.results ? " results" : "")}>
                     {(absenceReason === 'Lesão' || absenceReason === 'Trabalho/férias') &&
                        <>
                           <img src={WaitingClock} className={"icon mr-2"} alt={"absence icon"}/>
                           <span className={"game-card-footer-suspended"}>{t("game_card.absent_until")} {absenceEndDate.toLocaleDateString().replaceAll('/', '.')}</span>
                        </>
                     }

                     {absenceReason === 'Procuro substituta/o' &&
                        <>
                           <img src={WaitingClock} className={"icon mr-2"} alt={"absence icon"}/>
                           <span className={"game-card-footer-suspended"}>{t("game_card.in_substitution")}</span>
                        </>
                     }

                     {absenceReason === 'Queremos desistir' &&
                        <>
                           <img src={WaitingClock} className={"icon mr-2"} alt={"absence icon"}/>
                           <span className={"game-card-footer-suspended"}>{t("game_card.in_withdrawal")}</span>
                        </>
                     }
                  </div>
               </div>
            </div>
         }
      </div>
   );
};

export default withRouter(GameCard);
